import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
import { Sparkles, Heart } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-cream-100 pt-20 pb-16 md:pt-32 md:pb-24 px-4" data-id="element-56">
      {/* Decorative background elements - Organic blobs */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-57">
        <div className="absolute -top-[10%] -right-[5%] w-[600px] h-[600px] rounded-[40%_60%_70%_30%/40%_50%_60%_50%] bg-peach-200/40 blur-3xl animate-pulse" style={{
        animationDuration: '8s'
      }} data-id="element-58" />
        <div className="absolute top-[20%] -left-[10%] w-[500px] h-[500px] rounded-[60%_40%_30%_70%/60%_30%_70%_40%] bg-coral-100/40 blur-3xl" data-id="element-59" />
        <div className="absolute bottom-[10%] right-[10%] w-[400px] h-[400px] rounded-[50%_50%_70%_30%/30%_70%_50%_50%] bg-terracotta-100/30 blur-3xl" data-id="element-60" />
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-62">
          <span className="inline-flex items-center px-5 py-2 rounded-full bg-peach-100 text-terracotta-600 text-sm font-bold mb-8 border border-peach-200 shadow-sm" data-id="element-63">
            <Heart className="w-4 h-4 mr-2 fill-current" data-id="element-64" />
            Tu transformación financiera empieza hoy
          </span>

          <h1 className="text-4xl md:text-6xl font-bold text-warm-gray leading-tight mb-6 tracking-tight" data-id="element-65">
            💸 ¿Cansada de que el dinero{' '}
            <span className="relative inline-block" data-id="element-66">
              <span className="relative z-10 text-coral-600" data-id="element-67">
                no te alcance?
              </span>
              <span className="absolute bottom-2 left-0 w-full h-3 bg-peach-200/60 -rotate-1 rounded-full -z-0" data-id="element-68"></span>
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-warm-800 mb-10 font-medium max-w-3xl mx-auto leading-relaxed" data-id="element-69">
            ¿De sentir que empiezas cada año igual… sin claridad, sin ahorro, y
            con esa sensación de que se te escapa de las manos?
          </p>

          <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-10 mb-12 border border-peach-100 shadow-warm-md mx-auto max-w-3xl relative" data-id="element-70">
            {/* Decorative quote marks */}
            <div className="absolute -top-6 -left-4 text-6xl text-peach-300 font-serif opacity-50" data-id="element-71">
              "
            </div>

            <p className="text-lg md:text-xl text-warm-800 leading-relaxed font-medium" data-id="element-72">
              <span className="font-bold text-coral-600" data-id="element-73">NO es tu culpa.</span>{' '}
              Nadie te enseñó a manejar el dinero con amor y estrategia. Pero sí
              es tu momento de cambiarlo.
              <br className="hidden md:block" data-id="element-74" />
              <span className="font-bold text-terracotta-600 block mt-2" data-id="element-75">
                2026 puede ser diferente.
              </span>{' '}
              Si tú decides que lo sea.
            </p>
          </div>

          
        </motion.div>
      </div>
    </section>;
}